// import { AdsGramController } from './ads-gram/AdsGram'
import { MonetagController } from './monetag/Monetag'
import { Onclicka } from './onclicka/Onclicka'
import { Richads } from './richads/Richads'
import Tads from './tads/Tads'

// Універсальний ccclass-декоратор, як у AdsGramController
function maybeCcClass(name: string): ClassDecorator {
  if (typeof window !== 'undefined' && (window as any).cc && (window as any).cc._decorator) {
    return (window as any).cc._decorator.ccclass(name)
  }
  return () => {}
}

const STORAGE_KEY = 'ads_view_data'

export class AdsManagerForBank {
  private static _instance: AdsManagerForBank
  private constructor() {}

  public static get Instance(): AdsManagerForBank {
    if (!AdsManagerForBank._instance) {
      AdsManagerForBank._instance = new AdsManagerForBank()
    }
    return AdsManagerForBank._instance
  }

  private monetag!: MonetagController
  private onclicka!: Onclicka
  private richads!: Richads
  private tads!: Tads

  private currentProviderIndex: number = 0

  private viewData: ViewData = {
    day: '',
    dayCount: 0,
    hour: 0,
    hourCount: 0,
  }

  private rewarded_providers: AdProvider[] = [
    {
      name: 'monetag',
      show: () => this.monetag.showRewardedInterstitial(),
      requiresPreload: true,
    },
    {
      name: 'richads',
      show: () => this.richads.showAd_Rewarded(),
      requiresPreload: false,
    },
    {
      name: 'onclicka',
      show: () => this.onclicka.showAd_Rewarded(),
      requiresPreload: false,
    },
    {
      name: 'tads',
      show: () => this.tads.showAd_Rewarded(),
      requiresPreload: true,
      preload: () => this.tads.init(),
    },
  ]

  public async init() {
    console.log('INITIALIZING ADS...')

    this.monetag = MonetagController.Instance
    this.onclicka = Onclicka.Instance
    this.richads = Richads.Instance
    this.tads = Tads.getInstance()

    this.monetag.loadSdk().then((res) => {
      console.log('MonetagController init success: ', res)
    })

    this.onclicka.init()
    await this.tads.init()

    this.loadViewData()
  }

  public async showAd_Rewarded_Intestitial(): Promise<boolean> {
    if (!this.canShowAd()) {
      console.warn('Ad limit reached (per hour or per day)')
      return false
    }

    const maxAttempts = this.rewarded_providers.length
    let attempts = 0
    let success = false

    while (attempts < maxAttempts) {
      const provider = this.rewarded_providers[this.currentProviderIndex]
      this.currentProviderIndex = (this.currentProviderIndex + 1) % this.rewarded_providers.length

      success = await this.tryShowAdFromProvider(provider)
      if (success) {
        await this.patchAd()
        this.updateViewData()
        break
      }
      attempts++
    }

    if (!success) {
      console.warn('No ad was successfully shown from any provider.')
    }
    return success
  }

  private async tryShowAdFromProvider(provider: AdProvider): Promise<boolean> {
    try {
      if (provider.requiresPreload) {
        await provider.preload?.()
        console.log(`Ad successfully preloaded from: ${provider.name}`)
      }

      await provider.show()
      console.log(`Ad successfully shown from: ${provider.name}`)
      return true
    } catch (error) {
      console.warn(`Failed to show ad from: ${provider.name}`, error)
      return false
    }
  }

  private patchAd() {
    console.log('You have seen ad! Get your reward...')
  }

  private canShowAd(): boolean {
    const now = new Date()

    const today = now.toISOString().split('T')[0]
    const currentHour = now.getHours()

    if (this.viewData.day !== today) {
      this.viewData.day = today
      this.viewData.dayCount = 0
    }

    if (this.viewData.hour !== currentHour) {
      this.viewData.hour = currentHour
      this.viewData.hourCount = 0
    }

    return this.viewData.dayCount < 100 && this.viewData.hourCount < 10
  }

  private updateViewData() {
    const now = new Date()
    const today = now.toISOString().split('T')[0]
    const currentHour = now.getHours()

    if (this.viewData.day !== today) {
      this.viewData.day = today
      this.viewData.dayCount = 0
    }

    if (this.viewData.hour !== currentHour) {
      this.viewData.hour = currentHour
      this.viewData.hourCount = 0
    }

    this.viewData.dayCount += 1
    this.viewData.hourCount += 1

    this.saveViewData()
  }

  private loadViewData() {
    const json = localStorage.getItem(STORAGE_KEY)
    if (json) {
      try {
        this.viewData = JSON.parse(json)
      } catch (e) {
        console.warn('Failed to parse view data:', e)
      }
    }
  }

  private saveViewData() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.viewData))
  }
}

interface AdProvider {
  name: string
  preload?: () => Promise<any>
  show: () => Promise<any>
  requiresPreload: boolean
}

interface ViewData {
  day: string
  dayCount: number
  hour: number
  hourCount: number
}
